import ReactGA from "react-ga4";

const apiKey = process.env.REACT_APP_MEASUREMENT_ID

const initializeGA = () => {
  ReactGA.initialize(apiKey, {
    gaOptions: { anonymize_ip: true, debug: true },
    gtagOptions: { anonymize_ip: true, debug: true }
  });
};

// data streams measurement id
// cocaredirectory.com
// G-GKDS0Q1M30
// gtag
// G-MBDVFQGNBN


// ownpath.co data stream and gtag
// G-9L5WD4V6NV

/*
Structure for passing an event with a value dt 7/9/2025
import ReactGA from 'react-ga';

// ... (your component or function)

ReactGA.event({
  category: 'User Interaction',
  action: 'Button Click',
  label: 'Submit Form', // Optional
  value: 10, // The numerical value associated with the event
  nonInteraction: false, // Optional, set to true if the event doesn't affect bounce rate
});
Explanation of the options.value parameter:
value: This property is used to assign a numerical value to the event. For example, it could represent the revenue generated by a purchase, a score in a game, or any other quantifiable metric relevant to your event tracking.
Data Type: The value must be a number.
Optional: While category and action are required for ReactGA.event, value is an optional parameter.
By including the value property in your ReactGA.event call, you can send specific numerical data along with your event, which can be valuable for analyzing user behavior and event performance in Google Analytics.
*/

export const logPageView = () => {
  initializeGA();
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};

export const logEvent = (
  action: AnalyticsAction,
  properties?: AnalyticsEventProperties
) => {
  initializeGA();
  console.log('in logEvent and action is ' + action)
  console.log('in logEvent and properties are ' + properties?.timeSpan)
  if (action === 'Provider Search Time')
  {
    console.log('in logEvent and properties?.timeSpan is ' + properties?.timeSpan || 0)
    ReactGA.event(
      {
      category: 'User Interaction',
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
      action: AnalyticsAction.ProviderSearchTime, 
      label: 'Provider Search Time',
      value: properties?.timeSpan || 0,
      nonInteraction: false
    });
  }
  else 
    ReactGA.event(action, properties || {});
};

export enum AnalyticsAction {
  CompleteGuidedSearchQuestion = "Complete guided search question",
  CompleteGuidedSearch = "Complete guided search",
  CompleteZipSearch = "Complete zip search",
  UpdateFilter = "Update filter",
  ApplyFilter = "Apply filter",
  ToggleResultView = "Toggle result view",
  ClickMapMarker = "Click map marker",
  SearchError = "Search error",
  ViewSearchResults = "View search results",
  ClickShare = "Click share",
  SelectLocationForCompare = "Select location for compare",
  ViewCompare = "View compare",
  ReturnToSearch = "ReturnToSearch",
  ClickPaginationButton = "Click Pagination Button for results",
  VisitSurveyFromFooter = "Click OwnPath Survey Link in Footer ",
  VisitSurveyFromPrompt = "Click OwnPath Survey Link in prompt pop up",
  SearchProviderByName = "Search for provider by name",
  HomeLinkToRequestInclusion = "Home link to request inclusion Link",
  FooterLinktoRequestInclusion ="Footer Request to add Link",
  ProviderSearchInclusion = "Provider Search request Inclusion Link",
  ProviderDetailUpdateInclusion = "Provider Detail Search report missing Link",
  FAQProviderUpdateRequestInclusion = "FAQ Provider Update Request Inclusion",
  FAQProviderUpdateReportMissing = "FAQ Provider Update Report Missing Link",
  SelectProviderDetail = "Select Provider Detail",
  ProviderSearchTime = "Provider Search Time"
}

type AnalyticsEventProperties = {
  count?: number;
  filter_count?: number;
  filter_type?: string;
  filter_value?: string;
  label?: string;
  search?: string;
  step?: number;
  url?: string;
  pageNumber?: number;
  timeSpan?: number
};
